import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
} from "@mui/material";
import { Share as SocialIcon } from "@mui/icons-material";
import CustomInput from "../FormFields/CustomInput/CustomInput";
import CardHeaderComponent from "./CardHeaderComponent";

const CandidateSocialForm = ({ handleChange, formData }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 2,
        borderColor: '#e2e8f0',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        overflow: 'hidden',
      }}
    >
      <CardHeaderComponent icon={SocialIcon} title="Social" />
      <CardContent sx={{ p: 2.5 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Facebook URL"
              name="facebook"
              onChange={handleChange}
              value={formData?.facebook || ""}
              fullWidth
              size="small"
              placeholder="Enter Facebook profile URL"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Twitter URL"
              name="twitter"
              onChange={handleChange}
              value={formData?.twitter || ""}
              fullWidth
              size="small"
              placeholder="Enter Twitter profile URL"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomInput
              label="Linkedin URL"
              name="linkedin"
              onChange={handleChange}
              value={formData?.linkedin || ""}
              fullWidth
              size="small"
              placeholder="Enter LinkedIn profile URL"
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CandidateSocialForm;